import { render, staticRenderFns } from "./companyCardList.vue?vue&type=template&id=50b6b54f&scoped=true"
import script from "./companyCardList.vue?vue&type=script&lang=js"
export * from "./companyCardList.vue?vue&type=script&lang=js"
import style0 from "./companyCardList.vue?vue&type=style&index=0&id=50b6b54f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b6b54f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b6b54f')) {
      api.createRecord('50b6b54f', component.options)
    } else {
      api.reload('50b6b54f', component.options)
    }
    module.hot.accept("./companyCardList.vue?vue&type=template&id=50b6b54f&scoped=true", function () {
      api.rerender('50b6b54f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parkCustomer/components/companyCardList.vue"
export default component.exports